import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountingMigrationRow, formatMigrationEndDate } from "../utils";

export const EndDateCell = memo(function EndDateCell({
    row,
}: CellContext<ViewTableFeatures, AccountingMigrationRow, unknown>) {
    return (
        <ViewTableCell>
            {formatMigrationEndDate(row.original.entity.bookkeepingStartDate)}
        </ViewTableCell>
    );
});
